export default "__VITE_ASSET__CtgE5MUo__"